





















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import debounce from 'debounce';
import { IField } from '@/fields/types/field';
import FieldInput from '@/fields/components/FieldInput.vue';
import FieldContentContainer from '@/fields/components/FieldContentContainer.vue';
import { validateRegex } from '@/helpers/validation.helper';

@Component({
  components: {
    FieldInput,
    FieldContentContainer,
  },
})
export default class FormattedField extends Vue {
  @Prop() field!: IField;
  @Prop({ default: false }) editMode: boolean;
  @Prop({ default: false }) isActive: boolean;
  @Prop({ default: false }) isRequired: boolean;
  @Prop({ default: false }) isDragging: boolean;
  @Prop() hasValidatedValue: boolean;
  @Prop() showInitials: boolean;

  invalid: boolean = false;

  @Watch('field')
  updateValidation() {
    this.validate(this.field.value);
  }

  get fieldValue(): string {
    return this.field.value || this.field.label;
  }

  get hasValue(): boolean {
    return !!this.field.value || this.editMode;
  }

  validate(value: string): boolean {
    if (!value) {
      return;
    }
    if (!validateRegex(this.field.validationRegex, value)) {
      this.invalid = true;
      this.$emit('invalidInput', this.invalid);
      return false;
    }
    this.invalid = false;
    this.$emit('invalidInput', this.invalid);
    return true;
  }

  handleEnter() {
    this.$emit('deactivate', this.field.id);
  }

  debounceHandleUpdate: (payload: string) => void = debounce(
    (payload: string) => this.handleUpdate(payload),
    300
  );

  handleUpdate(payload: string) {
    this.validate(payload);
    this.$emit('updateValue', payload);
  }

  handleBlur() {
    this.validate(this.field.value);
  }

  mounted() {
    this.validate(this.field.value);
  }
}
